import { render, staticRenderFns } from "./DeleteAccountBtn.vue?vue&type=template&id=da13ca1e&"
import script from "./DeleteAccountBtn.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports